The latest event to replay.
